import React from "react";

import FAQList from "../components/FAQ/FAQList";
import entrepreneurFAQs from "../data/faqs/entrepreneur";

export default function EntrepreneurFAQ() {
    return (
        <FAQList
            faqs={entrepreneurFAQs}
            title="Entrepreneur FAQs"
            subtitle="Get information about our funding process and requirements"
        />
    );
}
